import React from 'react';
import moment from 'moment';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faBan } from '@fortawesome/free-solid-svg-icons/faBan';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';
import ListResource from './ListResource.jsx';

const api = '/api/site/announcements';

const ListAnnouncements = () => {
  const [res, req] = useHttpStatus();

  return (
    <ListResource
      {...{
        searchable: true,
        api,
        sort: { publishAt: -1 },
        cols: [
          {
            key: 'publishAt',
            sortable: true,
            getter: (v) => moment(v).format('YYYY/M/D h:mm a'),
          },
          {
            key: 'popup',
            sortable: true,
            getter(v) {
              return v ? (
                <FA icon={faCheck} />
              ) : '';
            },
          },
          {
            key: 'popupFreq',
            children: 'Frequency',
            sortable: true,
          },
          {
            key: 'frontpage',
            sortable: true,
            getter(v) {
              return v ? (
                <FA icon={faCheck} />
              ) : '';
            },
          },
          { key: 'title', sortable: true },
          {
            key: 'updatedAt',
            sortable: true,
            getter: (v) => moment(v).format('YYYY/M/D h:mm a'),
          },
        ],
      }}
    >
      {({ refresh }) => (
        <FormHttpBtn
          res={res}
          className="btn btn-secondary float-right"
          icon={faBan}
          onClick={async () => {
            await req({
              url: `${api}/popup/disable`,
              method: 'patch',
            });

            refresh();
          }}
        >
          Turn Off Popups
        </FormHttpBtn>
      )}
    </ListResource>
  );
};

export default ListAnnouncements;
